let spriteData = false;
let frame = 0;
let state = 2;
let spriteUpdate = false;
const speed = 400;
let hit = false;
let direction = 1;
let isDragging = false;
let gamePlaying = false;
let velocitySamples = [];
let gameBuilt = false;
const sampleSize = 5;
const sampleInterval = 50;
let startX = 0, startY = 0, lastX = 0, lastY = 0;
const gameLength = 60;
let tr = gameLength;
let playTime = false;
let score = 0;
let throwCount = 0;
let streak = 0;
let lastHitTime = 0;
let throw_history = [];

let start = document.querySelector('.start');
let popUp = document.querySelector('.pop-up');
let popUpText = document.querySelector('.pop-up-text');
let scoreAnnouncer = null;
let currentCanvas = null;

export default function game(){
  // Only initialize if game elements exist on the page
  const canvas = document.getElementById('gameCanvas');
  if (!canvas) return;

  // Reset gameBuilt if the canvas has changed (e.g., after AJAX navigation)
  if (gameBuilt && currentCanvas !== canvas) {
    gameBuilt = false;
  }

  if(!gameBuilt){

  currentCanvas = canvas;

  start = document.querySelector('.start');
  popUp = document.querySelector('.pop-up');
  popUpText = document.querySelector('.pop-up-text');

  if (!start || !popUp || !popUpText) return;

  popUpText.innerHTML = `How many bones can you feed Barney in ${gameLength} seconds`;

  // Create live region for screen reader announcements
  if (!document.getElementById('score-announcer')) {
    scoreAnnouncer = document.createElement('div');
    scoreAnnouncer.setAttribute('aria-live', 'polite');
    scoreAnnouncer.setAttribute('aria-atomic', 'true');
    scoreAnnouncer.className = 'visually-hidden';
    scoreAnnouncer.id = 'score-announcer';
    document.body.appendChild(scoreAnnouncer);
  } else {
    scoreAnnouncer = document.getElementById('score-announcer');
  }

  popUp.classList.remove('hidden');

  fetch("/assets/img/sprite.json")
  .then(response => response.json())
  .then(json =>
    spriteData = json
  );

const ctx = canvas.getContext('2d');

canvas.width = window.innerWidth;
canvas.height = window.innerHeight;

throwCount = 0;
// Random threshold between 3 and 7 throws before the dog changes position
let nextWalkThreshold = Math.floor(Math.random() * 5) + 3;
// Used to ensure we count a throw only once
let throwInProgress = false;

const dog = {
  x: 100,            // Starting X position
  y: 50,             // Y position (near the top)
  width: 100,        // Drawn width
  height: 100,       // Drawn height
  frameIndex: 0,     // Current animation frame
  frameCount: 2,     // Total frames in the spritesheet
  frameWidth: 150,   // Width of one frame (assumes a horizontal layout)
  frameHeight: 150,  // Height of one frame
  frameRate: 200,    // Milliseconds per frame
  elapsedTime: 0,    // Time accumulator for animation
  image: new Image(),
  state: "idle",     // "idle" or "walking"
  walkSpeed: 120,    // Pixels per second when walking
  targetX: 100, 
  targetY: 100       // Target X position when walking
};


dog.image.src = '/assets/img/sprite.png';

dog.image.width = 1804;
dog.image.style.width = '1804px';


start.addEventListener('click', function(){
  popUp.classList.add('hidden');
  popUp.setAttribute('aria-hidden', 'true');
  canvas.classList.remove('no-interact');
  gameStart();

  // Announce game start to screen readers
  if (scoreAnnouncer) {
    scoreAnnouncer.textContent = `Game started. ${gameLength} seconds remaining. Drag bones upward to throw them to Barney.`;
  }
});

// Keyboard support for start button
start.addEventListener('keydown', function(e){
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    start.click();
  }
});


// Dog treat object – this will be thrown by the player.
const treat = {
  x: (canvas.width / 2 ),
  y: canvas.height - 50,
  width: 90,
  height: 50,
  active: false,
  velocityX: 0,
  velocityY: 0,
  image: new Image()
};
treat.image.src = '/assets/img/bone.png';

// Handle window resize
function resizeCanvas() {
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
  if (!treat.active) {
    treat.x = canvas.width / 2;
    treat.y = canvas.height - 50;
  }
}
window.addEventListener('resize', resizeCanvas);

// Physics — no gravity, just deceleration like a real thrown object
const dragRate = 1.8;    // deceleration rate — bone slows naturally through the air
const landingSpeed = 200; // bone thuds down as soon as it starts feeling slow


// Only allow a throw if started from the bottom third of the screen.
const allowedThrowY = canvas.height * (2/3); // e.g. 600 * 2/3 = 400

canvas.addEventListener('mousedown', function (e) {
  if (!treat.active) {
    const rect = canvas.getBoundingClientRect();
    const currentY = e.clientY - rect.top;

    if (currentY < allowedThrowY) return; // Only allow throws from bottom 1/3

    startX = e.clientX - rect.left;
    startY = currentY;
    isDragging = true;

    treat.x = startX;
    treat.y = startY;
    velocitySamples = []; // Reset velocity samples

    // Start sampling velocity
    sampleVelocity();
  }
});


canvas.addEventListener('mousemove', function (e) {
  if (isDragging) {
    const rect = canvas.getBoundingClientRect();
    lastY = e.clientY - rect.top;
    lastX = e.clientX - rect.left;

    // Bone follows finger but stays clamped in throw zone visually
    treat.x = lastX;
    treat.y = Math.max(lastY, allowedThrowY);

    // Track real finger position for velocity (not clamped)
    velocitySamples.push({
      x: lastX,
      y: lastY,
      time: Date.now(),
    });

    if (velocitySamples.length > sampleSize) {
      velocitySamples.shift();
    }
  }
});

canvas.addEventListener('mouseup', function () {
  if (isDragging && !treat.active) {
    if (velocitySamples.length < 2) {
      isDragging = false;
      return;
    }

    // Compute velocity based on the last few movement samples
    const velocities = computeVelocity(velocitySamples);

    // Require a meaningful upward swipe
    if (velocities.vy > -80) {
      isDragging = false;
      return;
    }

    treat.velocityX = velocities.vx;
    treat.velocityY = velocities.vy;

    treat.x = lastX;
    treat.y = lastY;
    treat.active = true;
    treat.width = 90;
    treat.height = 50;
    throwInProgress = true;
  }

  isDragging = false;

});

canvas.addEventListener('touchstart', function(e) {

  if (!treat.active) {
    const rect = canvas.getBoundingClientRect();
    const touch = e.changedTouches ? e.changedTouches[0] : null;
    if (!touch) return;

    const currentY = touch.clientY - rect.top;
    if (currentY < allowedThrowY) return; 

    startX = touch.clientX - rect.left;
    startY = currentY;
    isDragging = true;

    treat.x = startX;
    treat.y = startY;
    velocitySamples = []; // Reset velocity samples

    // Start sampling velocity
    sampleVelocity();
  }

  e.preventDefault();

});


canvas.addEventListener('touchmove', function (e) {
  if (isDragging) {
    const rect = canvas.getBoundingClientRect();
    const touch = e.changedTouches ? e.changedTouches[0] : null;
    if (!touch) return;

    lastY = touch.clientY - rect.top;
    lastX = touch.clientX - rect.left;

    // Bone follows finger but stays clamped in throw zone visually
    treat.x = lastX;
    treat.y = Math.max(lastY, allowedThrowY);

    // Track real finger position for velocity (not clamped)
    velocitySamples.push({
      x: lastX,
      y: lastY,
      time: Date.now(),
    });

    if (velocitySamples.length > sampleSize) {
      velocitySamples.shift();
    }
  }

});


canvas.addEventListener('touchend', function(e) {

  if (isDragging && !treat.active) {
    if (velocitySamples.length < 2) {
      isDragging = false;
      return;
    }

    // Compute velocity based on the last few movement samples
    const velocities = computeVelocity(velocitySamples);

    // Require a meaningful upward swipe
    if (velocities.vy > -80) {
      isDragging = false;
      e.preventDefault();
      return;
    }

    treat.velocityX = velocities.vx;
    treat.velocityY = velocities.vy;

    treat.x = lastX;
    treat.y = lastY;
    treat.active = true;
    treat.width = 90;
    treat.height = 50;
    throwInProgress = true;
  }

  isDragging = false;
  e.preventDefault();

});

// Function for collision detection between the treat and the dog.
const checkCollision = (treatObj, dogObj) => {
  // Check if the treat's centre lies within the dog's drawn rectangle.
  return (treatObj.x >= dogObj.x &&
          treatObj.x <= dogObj.x + dogObj.width &&
          treatObj.y >= dogObj.y &&
          treatObj.y <= dogObj.y + dogObj.height);
};

// Function fired when the treat hits the dog.
const hitDog = () => {
  const now = Date.now();

  // Check for streak (hits within 3 seconds count as streak)
  if (now - lastHitTime < 3000) {
    streak++;
  } else {
    streak = 1;
  }
  lastHitTime = now;

  // Bonus points for streaks
  const points = streak >= 3 ? 2 : 1;
  score += points;

  // Announce score to screen readers
  if (scoreAnnouncer) {
    const streakText = streak >= 3 ? ` Streak x${streak}!` : '';
    scoreAnnouncer.textContent = `Score: ${score}${streakText}`;
  }

  hit = true;
  setTimeout(function(){
    hit = false;
  }, 1500);
};

// Main game loop using requestAnimationFrame.
let lastTime = performance.now();

const gameLoop = (timestamp) => {
 
  const deltaTime = (timestamp - lastTime) / 1000; // in seconds
  lastTime = timestamp;
  

  if(gamePlaying){
    tr = gameLength - Math.ceil((Date.now() - playTime)/ 1000); // in seconds
    if(tr <= 0){
      
      tr = 0;
      gamePlaying = false;

      let resultMessage = `Game over! You fed Barney ${score} bone${score !== 1 ? 's' : ''}.`;
      if (score >= 20) {
        resultMessage += ' Amazing!';
      } else if (score >= 10) {
        resultMessage += ' Great job!';
      } else if (score >= 5) {
        resultMessage += ' Not bad!';
      }
      popUpText.innerHTML = resultMessage;
      start.innerHTML = 'Play Again';
      popUp.classList.remove('hidden');
      popUp.setAttribute('aria-hidden', 'false');
      canvas.classList.add('no-interact');

      // Announce game over to screen readers
      if (scoreAnnouncer) {
        scoreAnnouncer.textContent = resultMessage;
      }

      // Focus the play again button for keyboard users
      setTimeout(() => start.focus(), 100);
    }
  }
  

  update(deltaTime);
  draw();

  // Continue game loop if canvas still exists
  if(document.getElementById('gameCanvas')){
    requestAnimationFrame(gameLoop);
  }

};

// Update positions, animations and game logic.
const update = (deltaTime) => {
  // Update the dog's animation frame.
  dog.elapsedTime += deltaTime * 1000;
  
  // If the dog is walking, move horizontally toward its target position.
  if (dog.state === "walking") {

    // Always use walking sprites while moving
    state = 0;


    if (Math.abs(dog.x - dog.targetX) < dog.walkSpeed * deltaTime) {
    
      dog.x = dog.targetX;
      dog.state = "idle"; 
     
    } else {

      if (dog.x < dog.targetX) {
        dog.x += dog.walkSpeed * deltaTime;
        direction = 1;
      } else {
        dog.x -= dog.walkSpeed * deltaTime;
        direction = -1;
      }
    }

    if (Math.abs(dog.y - dog.targetY) < dog.walkSpeed * deltaTime) {
        dog.y = dog.targetY;
    } else {
       
        if (dog.y < dog.targetY) {
          dog.y += dog.walkSpeed * deltaTime;
        } else {
          dog.y -= dog.walkSpeed * deltaTime;
        }
    }

  }else{
    if(hit){
      state = 4;
    }else{
      state = 2;
    }
    
  }

  // Update the treat's position if active — straight-line throw with deceleration
  if (treat.active) {
    // Decelerate — bone slows naturally like air resistance
    const dragFactor = Math.pow(0.5, deltaTime * dragRate);
    treat.velocityX *= dragFactor;
    treat.velocityY *= dragFactor;

    treat.x += treat.velocityX * deltaTime;
    treat.y += treat.velocityY * deltaTime;

    // Check collision throughout the toss
    if (checkCollision(treat, dog)) {
      hitDog();
      resetTreat();
      return;
    }

    // Current speed
    const speed = Math.sqrt(treat.velocityX * treat.velocityX + treat.velocityY * treat.velocityY);

    // In flight — full size
    treat.width = 70;
    treat.height = 40;

    // Thud — bone hits the ground abruptly when it's lost enough speed
    if (speed < landingSpeed) {
      // Quick squash frame — wider and shorter, like impact
      treat.width = 85;
      treat.height = 25;

      // Land immediately next frame
      if (!treat.landing) {
        treat.landing = Date.now();
      } else if (Date.now() - treat.landing > 100) {
        // 100ms squash then done
        throw_history.push({x: treat.x, y: treat.y});
        if (throw_history.length > 50) {
          throw_history.shift();
        }
        treat.landing = null;
        resetTreat();
        return;
      }
    }

    // Off screen
    if (treat.x < -50 || treat.x > canvas.width + 50 || treat.y < -50) {
      resetTreat();
    }
  }

  function resetTreat() {
    treat.velocityX = 0;
    treat.velocityY = 0;
    treat.active = false;
    treat.x = canvas.width / 2;
    treat.y = canvas.height - 50;
    treat.width = 90;
    treat.height = 50;
  }

  if (!treat.active && throwInProgress) {
    throwCount++;
    isDragging = false;
    throwInProgress = false;
    treat.width = 90;
    treat.height = 50;

    // Reset streak if miss
    streak = 0;
  }

  // Difficulty progression: dog moves more often and faster as time passes
  const timeElapsed = gamePlaying ? (Date.now() - playTime) / 1000 : 0;
  const difficultyMultiplier = 1 + (timeElapsed / gameLength) * 0.5; // Up to 1.5x at end

  if (throwCount >= nextWalkThreshold && dog.state === "idle") {
    const minX = 10;
    const maxX = canvas.width - dog.width - 50;
    const newX = Math.floor(Math.random() * (maxX - minX + 1)) + minX;
    dog.targetX = newX;

    const minY = 100;
    const maxY = (window.innerHeight / 2);
    const newY = Math.floor(Math.random() * (maxY - minY)) + minY;
    dog.targetY = newY;

    dog.state = "walking";
    dog.walkSpeed = 120 * difficultyMultiplier; // Faster as game progresses
    throwCount = 0;
    // Fewer throws needed between moves as difficulty increases
    nextWalkThreshold = Math.max(2, Math.floor((Math.random() * 5 + 3) / difficultyMultiplier));
  }
};

// Draw everything on the canvas.
const draw = () => {

  ctx.clearRect(0, 0, canvas.width, canvas.height);

  const tempWidth = 17;
  const tempHeight = 10;

  for (let a = 0; a < throw_history.length; a++) {
    ctx.drawImage(treat.image, throw_history[a].x - (tempWidth/2),  throw_history[a].y - (tempWidth/2), tempWidth, tempHeight);
  }
  

  if(spriteData){
    const now = Date.now();

    if(now - spriteUpdate > speed){
      frame = frame === 0 ? 1 : 0;
      spriteUpdate = now;
    }

    const sprit = spriteData['frames'][state+frame].frame;

    let w =  dog.width;
    let h = (sprit.h / sprit.w) * dog.width;

    if( sprit.w > sprit.h ){
       h =  dog.height;
       w = (sprit.w / sprit.h) * dog.width;
    }

    ctx.save(); // Save context state

    if (direction === -1) {
        ctx.scale(-1, 1); // Flip horizontally
        ctx.drawImage(
            dog.image,
            sprit.x, sprit.y, sprit.w, sprit.h,
            -dog.x - w, dog.y, w, h
        );
    } else {
        ctx.drawImage(
            dog.image,
            sprit.x, sprit.y, sprit.w, sprit.h,
            dog.x, dog.y, w, h
        );
    }

    ctx.restore(); // Restore context state
  }

  // Draw the bone (whether being dragged, in flight, or at rest)
  ctx.drawImage(treat.image, treat.x - treat.width / 2, treat.y - treat.height / 2, treat.width, treat.height);


  // Draw throw zone (shaded area at bottom)
  const throwZoneY = canvas.height * (2/3);
  ctx.fillStyle = "rgba(141, 136, 154, 0.15)"; // #8D889A with transparency
  ctx.fillRect(0, throwZoneY, canvas.width, canvas.height - throwZoneY);

  // Draw throw zone line
  ctx.strokeStyle = "rgba(141, 136, 154, 0.4)";
  ctx.lineWidth = 2;
  ctx.setLineDash([10, 10]);
  ctx.beginPath();
  ctx.moveTo(0, throwZoneY);
  ctx.lineTo(canvas.width, throwZoneY);
  ctx.stroke();
  ctx.setLineDash([]);
  ctx.lineWidth = 1;

  // Draw HUD
  ctx.fillStyle = "black";
  ctx.textRendering = "optimizeLegibility";

  if(canvas.width > 600){
    ctx.font = "20px monospace";
    ctx.fillText("Score:", 20, canvas.height - 100);
    ctx.fillText("Time:", canvas.width - 160, canvas.height - 100);

    ctx.font = "80px monospace";
    ctx.fillText(score, 20, canvas.height - 20);
    ctx.fillText(tr+"s", canvas.width - 160, canvas.height - 20);

    // Show streak indicator
    if (streak >= 2) {
      ctx.font = "24px monospace";
      ctx.fillStyle = streak >= 3 ? "#e63946" : "#333";
      ctx.fillText(`x${streak} streak!`, 20, canvas.height - 130);
    }
  } else {
    ctx.font = "14px monospace";
    ctx.fillText("Score:", 20, canvas.height - 60);
    ctx.fillText("Time:", canvas.width - 80, canvas.height - 60);

    ctx.font = "40px monospace";
    ctx.fillText(score, 20, canvas.height - 20);
    ctx.fillText(tr+"s", canvas.width - 80, canvas.height - 20);

    // Show streak indicator on mobile
    if (streak >= 2) {
      ctx.font = "16px monospace";
      ctx.fillStyle = streak >= 3 ? "#e63946" : "#333";
      ctx.fillText(`x${streak}!`, canvas.width / 2 - 20, canvas.height - 70);
    }
  }
  ctx.textRendering = "geometricPrecision";

};

gameBuilt = true;
requestAnimationFrame(gameLoop);

  }

}


function computeVelocity(samples) {
  if (samples.length < 2) return { vx: 0, vy: 0 };

  const first = samples[0];
  const last = samples[samples.length - 1];

  const dx = last.x - first.x;
  const dy = last.y - first.y;

  const dt = (last.time - first.time) / 1000;
  if (dt === 0) return { vx: 0, vy: 0 };

  // Toss — matched so speed and distance feel proportional
  let vX = (dx / dt) * 1.1;
  let vY = (dy / dt) * 1.1;

  // Minimum throw — just enough to leave your hand
  if (vY < 0 && vY > -150) {
    vY = -150;
  }

  // Cap velocities
  vX = Math.max(-700, Math.min(700, vX));
  vY = Math.max(-1000, Math.min(0, vY));

  return { vx: vX, vy: vY };
}

function sampleVelocity() {
  
  if (!isDragging) return;

  velocitySamples.push({
    x: lastX,
    y: lastY,
    time: Date.now(),
  });

  if (velocitySamples.length > sampleSize) {
    velocitySamples.shift();
  }

  setTimeout(sampleVelocity, sampleInterval);

}

function gameStart(){
  gamePlaying = true;
  playTime = Date.now();
  score = 0;
  throwCount = 0;
  tr = gameLength;
  streak = 0;
  lastHitTime = 0;
  throw_history.length = 0; // Clear the bone pile
}